import api from '../utils/api';

// ✅ Lister toutes les factures
export const getAllInvoices = async () => {
    try {
        const response = await api.get('/invoices');
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch invoices');
    }
};

// ✅ Obtenir une facture par ID
export const getInvoiceById = async (id) => {
    try {
        const response = await api.get(`/invoices/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch invoice');
    }
};

// ✅ Obtenir les factures par statut
export const getInvoicesByStatus = async (status) => {
    try {
        const response = await api.get(`/invoices/status/${status}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch invoices by status');
    }
};

// ✅ Lister les factures en retard
export const getOverdueInvoices = async () => {
    try {
        const response = await api.get('/invoices/overdue');
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch overdue invoices');
    }
};

// ✅ Créer une nouvelle facture
export const createInvoice = async (invoiceData) => {
    try {
        const response = await api.post('/invoices', invoiceData);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to create invoice');
    }
};

// ✅ Mettre à jour une facture
export const updateInvoice = async (id, invoiceData) => {
    try {
        const response = await api.put(`/invoices/${id}`, invoiceData);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to update invoice');
    }
};

// ✅ Supprimer une facture
export const deleteInvoice = async (id) => {
    try {
        const response = await api.delete(`/invoices/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to delete invoice');
    }
};

// ✅ Enregistrer un paiement
// Service pour l'enregistrement de paiement
export const recordPayment = async (id, montant) => {
    try {
        const response = await api.post(`/invoices/${id}/payment?montant=${montant}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Échec lors de l\'enregistrement du paiement');
    }
};

// ✅ Montant total en attente de paiement
export const getTotalPendingAmount = async () => {
    try {
        const response = await api.get('/invoices/statistics/pending-amount');
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch pending amount');
    }
};

// ✅ Montant total payé dans une période
export const getTotalPaidInPeriod = async (startDate, endDate) => {
    try {
        const response = await api.get('/invoices/statistics/paid-in-period', {
            params: { startDate, endDate }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || new Error('Failed to fetch total paid in period');
    }
};
